import { EVENTS_ADD, EVENTS_SET } from '../actions/actionTypes';

const initialState = {
  entries: []
};

const reducer = (state = initialState, action) => {
  if (action.type === EVENTS_SET) {
    return { entries: action.entries };
  }

  if (action.type === EVENTS_ADD) {
    const newState = { ...state };

    const newEntries = action.entries.filter(val => {
      const existingIndex = newState.entries.findIndex(current => current.id === val.id);
      if (existingIndex === -1) {
        return !val.isCancelled;
      }

      if (val.isCancelled) {
        delete newState.entries[existingIndex];
        newState.entries = newState.entries.filter(val => val !== undefined);

        return false;
      }

      newState.entries[existingIndex] = val;

      return false;
    });

    newState.entries = newState.entries.concat(newEntries).filter(val => val !== undefined)

    return newState;
  }

  return state;
};

export default reducer;
